import React from "react";
import { useCurrentFrame, interpolate } from "remotion";

const Icon1 = () => {
  const frame = useCurrentFrame();

  const firstDotRotation = interpolate(frame, [10, 30], [90, 0], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });
  const firstDotScale = interpolate(frame, [10, 30], [0, 1], {
    extrapolateLeft: "clamp",
    extrapolateRight: "clamp",
  });

  const secondDotRotation = interpolate(frame, [0, 20], [-90, 0], {
    extrapolateRight: "clamp",
  });
  const secondDotScale = interpolate(frame, [0, 20], [0, 1], {
    extrapolateRight: "clamp",
  });

  return (
    <svg
      id="Layer_2"
      data-name="Layer 2"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 210 265"
      style={{ height: "1.5em", width: "auto", overflow: "visible" }}
    >
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          className="fill-vibrant-green"
          d="M95.62,1.31c11.45-3.71,23.92.66,30.26,10.43,5.82,8.97,5.43,20.86-1.04,29.74-20.17,13.39-40.35,26.78-60.52,40.17,34.78,23.65,69.57,47.3,104.35,70.96,2.12,3.3,8.54,14.18,7.3,29.22-1.24,15.06-9.37,24.75-12,27.65-47.65-31.83-95.3-63.65-142.96-95.48-2.38-2.58-14-15.68-12.97-35,.68-12.8,6.58-21.83,9.32-25.52C43.45,36.1,69.53,18.7,95.62,1.31Z"
        />
        <g
          style={{
            transform: `rotate(${firstDotRotation}deg) scale(${firstDotScale})`,
            transformOrigin: "102px 82px",
          }}
        >
          <path
            className="fill-bluest-blue"
            d="M151.98,58.15c5.12,1.4,19.76,8.64,20.33,23.91.59,15.68-14.22,24.75-20.61,25.9-3.58.65-7.3.29-7.3.29-3.08-.3-5.57-1.07-7.3-1.75-11.74-8.07-23.48-16.15-35.23-24.22l34.72-22.52c1.55-.83,4.25-2.03,7.8-2.35,0,0,3.65-.33,7.58.75Z"
          />
        </g>
        <path
          className="fill-bluest-blue"
          d="M12.93,133.84c52.8,34.96,105.59,69.91,158.39,104.87,7.39,10.39,7.05,24.25-.56,33.65-6.58,8.13-17.61,11.7-28.17,9.13-43.13-28.52-86.26-57.04-129.39-85.57-2.77-2.35-7.28-6.83-10.17-13.83-3.71-8.97-2.62-16.91-1.83-22.17,1.89-12.54,7.98-21.47,11.74-26.09Z"
        />
        <g
          style={{
            transform: `rotate(${secondDotRotation}deg) scale(${secondDotScale})`,
            transformOrigin: "90px 255px",
          }}
        >
          <path
            className="fill-vibrant-green"
            d="M17.44,232.68c-7.81,2.81-18.16,12.44-17.4,25.86.67,11.79,9.61,20.85,18.1,23.07,4.38,1.15,9.18.62,10.17.5,4.94-.6,8.72-2.29,10.98-3.53,10.69-7.4,21.37-14.8,32.06-22.2-11.57-7.71-23.13-15.43-34.7-23.14-2-.85-5.36-1.98-9.65-2.09,0,0-4.97-.13-9.58,1.54Z"
          />
        </g>
      </g>
    </svg>
  );
};

export default Icon1;
